import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useEmbedded } from 'hooks/useEmbedded';
import { usePageEventByQuery } from 'queries/events/usePageEventByQuery';

import MdlbeastEmbed from 'components/@events/MdlbeastEmbed';
import AppNavigation from 'components/@navigation/AppNavigation';
import PageBreadcrumbs from 'components/@navigation/PageBreadcrumbs';
import PageSeo from 'components/@seo/PageSeo';

const EventLineupIframePage = () => {
  const router = useRouter();
  const { slug } = router.query;
  const { isEmbedded } = useEmbedded();
  const { event } = usePageEventByQuery();

  const mdlbeastLineupPath = event?.mdlbeastLineupPath;

  // Breadcrumb items
  const breadcrumbItems = slug
    ? [
        {
          href: `/events/${slug}`,
          label: event?.title || 'Event',
        },
        { label: <FormattedMessage id="event.header.tab.lineup" /> },
      ]
    : [
        {
          label: 'Back',
          onClick: () => router.back(),
        },
        { label: 'Lineup' },
      ];

  return (
    <AppNavigation hideFooterOnMobile={isEmbedded}>
      <PageSeo tags={event?.seoTags} />
      <Box sx={{ px: { xs: 2, md: 3 }, pt: 2 }}>
        <PageBreadcrumbs items={breadcrumbItems} />
      </Box>

      {mdlbeastLineupPath && (
        <MdlbeastEmbed
          path={mdlbeastLineupPath}
          title={`${event?.title} Lineup`}
        />
      )}
    </AppNavigation>
  );
};

export default EventLineupIframePage;
